import { GoToIcon } from 'assets/icons';
import {
  BBBright,
  BBLight95,
  BodyTextM,
  BodyTextMStrong,
  GRAY10,
  GRAY40,
  SubtitleM,
  SubTitleText,
} from 'global-styles';
import Image from 'next/image';
import React, { forwardRef } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { ProductCommonTitleKR } from '../ProductCommons';
import { en, ko } from './avifProductProvideContents';

interface Props {
  locale: string;
  isVisible: boolean;
}

const AvifProductProvide = forwardRef<HTMLElement, Props>(
  ({ locale, isVisible }, ref) => {
    const provideItems = locale === 'en' ? en : ko;
    return (
      <AvifProductProvideContainer ref={ref} isVisible={isVisible}>
        {locale === 'en' ? (
          <SubTitleText className="tt">How we deliver the product</SubTitleText>
        ) : (
          // <ProductCommonTitleEn className="tt">
          //   How we deliver the product
          // </ProductCommonTitleEn>
          <ProductCommonTitleKR>제품 제공방식</ProductCommonTitleKR>
        )}
        <ul className="provide-items">
          {provideItems.map((item, i) => (
            <AvifProductProvideItem
              key={item.t}
              as={i === 0 ? 'a' : 'li'}
              href={
                i === 0
                  ? 'https://avif-documentation.blue-dot.io/documentation/user/verify-user/'
                  : undefined
              }
              target={i === 0 ? '_blank' : undefined}
              data-link={i === 0}
            >
              <div className="img-wrapper">
                <div className="img-inner-wrapper">
                  <Image
                    quality={80}
                    className="img"
                    src={item.img_src}
                    alt=""
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
              </div>

              <SubtitleM className="t">{item.t}</SubtitleM>

              <BodyTextMStrong className="t-desc">
                {item.t_desc}
                {i === 0 && <GoToIcon />}
              </BodyTextMStrong>

              <BodyTextM className="desc">{item.desc}</BodyTextM>
            </AvifProductProvideItem>
          ))}
        </ul>
      </AvifProductProvideContainer>
    );
  }
);

AvifProductProvide.displayName = 'AvifProductProvide';

export default AvifProductProvide;

const AvifProductProvideContainer = styled.article<{ isVisible: boolean }>`
  padding: 96px 0;
  overflow: hidden;
  /* margin-bottom: 192px; */
  .provide-items {
    display: flex;
    width: 100%;
    padding-top: 20px;
  }
  .tt {
    display: block;
    margin: 32px 0 24px;
  }
  ${({ isVisible }) =>
    isVisible &&
    css`
      .tt {
        opacity: 1;
      }
      .provide-items {
        opacity: 1;
      }
    `};
  @media screen and (max-width: 1240px) {
    margin-bottom: 96px;
  }
  @media screen and (max-width: 904px) {
    padding: 56px 0;
    margin-bottom: 56px;
    .provide-items {
      flex-direction: column;
    }
  }
  @media screen and (max-width: 599px) {
    padding: 32px 0;
    margin-bottom: 32px;
  }
`;

const scaleInfinite = keyframes`
  0%, 100% {
    transform: scale(1);
  } 50% {
    transform: scale(1.2);
  }
`;

const AvifProductProvideItem = styled.li`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 16px 24px;

  &[data-link='true']:hover {
    text-decoration: underline;
  }

  &[data-link='true'] .img-wrapper {
    animation: ${scaleInfinite} 2s infinite;
  }

  .img-wrapper {
    background: ${BBLight95};
    border-radius: 50%;
    width: 168px;
    height: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .img-inner-wrapper {
    position: relative;
    width: 120px;
    height: 120px;
  }
  .img {
    width: 100%;
    height: 100%;
  }
  .t {
    margin-top: 20px;
    color: ${GRAY10};
  }
  .t-desc {
    color: ${BBBright};
    text-align: center;
  }
  svg {
    margin-left: 8px;
  }
  .desc {
    margin-top: 8px;
    color: ${GRAY40};
  }
  @media screen and (max-width: 1239px) {
    padding: 16px 20px;
  }
  @media screen and (max-width: 904px) {
    padding: 16px 80px;
  }
  @media screen and (max-width: 599px) {
    padding: 16px 0;
  }
`;
